var _defs, _g, _g2, _rect, _path, _rect2, _rect3, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Coding_Search",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 366.28 524.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "267.3 117.76 267.35 194.06 267.49 367.74 17.34 367.74 17.34 65.66 210.78 66.12 267.3 117.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "285.71 230.17 267.35 194.06 267.49 288.3 285.71 230.17"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M252.43,348.68v3.99H32.4V80.73H195.76l-.97,51.88,57.64,.45v21.49c5.3,2.67,10.34,5.79,15.06,9.32v-45.76l-57.35-.44,.98-52H17.34V367.74h250.15v-1.89l-15.06-17.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.43,332.73v.04l.11-.1s-.07,.04-.11,.05Z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 226.42,
    y: 59.23,
    width: 15.07,
    height: 76.55,
    transform: "translate(4.17 204.46) rotate(-47.58)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M207.84,328.19c-46.63,0-84.56-37.93-84.56-84.56s37.94-84.56,84.56-84.56,84.56,37.94,84.56,84.56-37.93,84.56-84.56,84.56Zm0-154.06c-38.32,0-69.5,31.18-69.5,69.5s31.18,69.5,69.5,69.5,69.5-31.18,69.5-69.5-31.18-69.5-69.5-69.5Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 275.24,
    y: 291.67,
    width: 15.07,
    height: 69,
    transform: "translate(-143.55 258.38) rotate(-40.04)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 279.75,
    y: 318.8,
    width: 45.19,
    height: 59.33,
    transform: "translate(-154.77 286.14) rotate(-41.29)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M262.28,243.62c0-11.59-3.66-22.34-9.85-31.17v62.35c6.2-8.84,9.85-19.59,9.85-31.18Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.e9f77722e53183704ac5e9c9bea4179b.svg";
export { ForwardRef as ReactComponent };